import React from 'react';
import { PencilSimple } from '@phosphor-icons/react';
import { formatShortDate } from '../../../../utils/dateUtils';
import tableStyles from '../../../../styles/tables.module.css';
import './TaskTable.css';

const CATEGORY_LABELS = {
  planning: 'תכנון',
  permits: 'רישוי',
  design: 'עיצוב',
  construction: 'בנייה',
};

const CATEGORY_COLORS = {
  planning: '#F1C40F',
  permits: '#3498DB',
  design: '#2ECC71',
  construction: '#E74C3C',
};

const STATUS_LABELS = {
  pending: 'ממתין',
  in_progress: 'בביצוע',
  completed: 'הושלם',
};

const STATUS_COLORS = {
  pending: '#95A5A6',
  in_progress: '#3498DB',
  completed: '#2ECC71',
};

export const TaskTable = ({ tasks, onTaskClick }) => {
  // Early return if no tasks
  if (!tasks) return null;

  const formatDate = dateString => {
    return formatShortDate(dateString);
  };

  return (
    <div className={tableStyles.tableContainer}>
      <table className={tableStyles.table}>
        <thead className={tableStyles.tableHeader}>
          <tr>
            <th className={tableStyles.headerCell}>שם משימה</th>
            <th className={tableStyles.headerCell}>קטגוריה</th>
            <th className={tableStyles.headerCell}>סטטוס</th>
            <th className={tableStyles.headerCell}>תאריך התחלה</th>
            <th className={tableStyles.headerCell}>תאריך סיום</th>
            <th className={tableStyles.headerCell}>פעולות</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map(task => (
            <tr key={task.id} className={tableStyles.row} onClick={() => onTaskClick(task.id)}>
              <td className={tableStyles.cell}>
                <div className="task-name-cell">
                  <span>{task.text}</span>
                  {task.type === 'milestone' && (
                    <span className={tableStyles.badge} style={{ backgroundColor: '#9333ea' }}>
                      אבן דרך
                    </span>
                  )}
                </div>
              </td>
              <td className={tableStyles.cell}>
                <span
                  className={tableStyles.badge}
                  style={{ backgroundColor: CATEGORY_COLORS[task.category] }}
                >
                  {CATEGORY_LABELS[task.category]}
                </span>
              </td>
              <td className={tableStyles.cell}>
                <span
                  className={tableStyles.badge}
                  style={{ backgroundColor: STATUS_COLORS[task.status] }}
                >
                  {STATUS_LABELS[task.status]}
                </span>
              </td>
              <td className={tableStyles.cell}>{formatDate(task.start_date)}</td>
              <td className={tableStyles.cell}>{formatDate(task.end_date)}</td>
              <td className={tableStyles.cell}>
                <button
                  className={tableStyles.actionButton}
                  onClick={e => {
                    e.stopPropagation();
                    onTaskClick(task.id);
                  }}
                  aria-label="ערוך"
                >
                  <PencilSimple size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskTable;
